<template>
  <div class="txt_box">
    <div class="left">
      <div class="logo"><img :src="require('@/assets/images/real-estate/logo.png')" /></div>
      <div class="title"><span>500</span>强房地产集团都在用的<br />电子签名解决方案</div>
      <!-- <div class="txt"><span>一站解决</span><span>场景全面</span><span>安全保障</span></div> -->
      <div class="txt">一站解决&nbsp;&nbsp;|&nbsp;&nbsp;场景全面&nbsp;&nbsp;|&nbsp;&nbsp;安全保障</div>
    </div>
    <div class="toTry hidden-sm">
      <div class="try-tit">免费试用</div>
      <div class="line">
        <input
          :class="[name === '请输入您的姓名(中文)' ? 'active_input' : '']"
          v-model="name"
          type="text"
          class="userName"
          placeholder="您的姓名"
          @focus="clearData(0)"
          @blur="onfousFun()"
        />
      </div>
      <!-- 20230413迭代，使用abtest分流:①.name_input表示（老）留资企业名称，不使用公司联想功能，②.name_association表示（新）留资企业名称，使用公司联想功能 -->
      <div class="line" v-if="abTestPlan === 'name_input'">
        <input
          :class="[companyName === '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称"
          @focus="clearData(1)"
          @blur="onfousFun()"
        />
      </div>
      <div class="line company-position" v-else>
        <input
          :class="[companyName === '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称"
          @focus="clearData(1)"
          @blur="onfousFun()"
          @keyup.enter="handleAssociativeInputSearch()"
          @input="() => changeInput()"
        />
        <!-- 20230413：增加企业名称支持联想输入 -->
        <transition name="el-fade-in-linear">
          <div class="company-list" v-if="companyList.length && companyName && showCompanyList">
            <p v-for="item in companyList" :key="item.certNo" @click="chooseOrg(item)" v-html="item.name"></p>
          </div>
        </transition>
      </div>
      <div class="line">
        <input
          :class="[phoneNumber === '请输入您的联系方式' ? 'active_input' : '']"
          v-model="phoneNumber"
          id="mobile"
          type="text"
          class="mobile"
          placeholder="手机号码"
          @focus="clearData(2)"
          @blur="onfousFun()"
        />
      </div>

      <div class="line">
        <div class="code-box code-box-boder">
          <input
            :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active_input' : '']"
            v-model="phoneCode"
            maxlength="6"
            type="text"
            class="code-input form-control code no_border"
            placeholder="验证码"
            @focus="clearData(3)"
            @blur="onfousFun()"
          />
          <span
            :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']"
            class="code-btn"
            id="code-btn"
            @click="handleFetchCodeClick()"
            >{{ codeName }}</span
          >
        </div>
      </div>
      <div class="line agreement-line" v-if="userAgreement.enable">
        <label class="wrapper">
          <input type="checkbox" v-model="agreement" /><span>我已阅读并同意<a :href="userAgreement.link" target="_blank">《隐私协议》</a></span>
        </label>
        <div v-show="showErrorTip" class="error-tip">请先阅读并同意协议</div>
      </div>
      <div class="btn-line">
        <div id="man-machine-slide"></div>
      </div>
      <div class="btn-try" :class="changeBtnBg ? 'bg_active1' : 'bg_active0'" @click="handleSendInfoBtnClick()" data-agl-cvt="5">
        {{ tryButtontxt }}
      </div>
      <!-- <a name="reg-pc" :href="`https://h5.esign.cn/usercenterFront/regist?pub=${pub}`" class="btn_zc">注册体验</a> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import formMixin from '../../../views/common/components/mixins/form.js'

export default {
  mixins: [formMixin],
  props: {
    landingPageName: {
      type: String,
      default: '',
    },
  },
  watch: {
    companyName(newVal, oldVal) {
      if(newVal) {
        this.companyList = []
        this.showCompanyList = true
      }
    }
  },
  computed: {
    ...mapState('abTest', ['abTestPlan']),
  }
}
</script>

<style lang="less" scoped>
.txt_box {
  width: 1180px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .left {
    // width: 463px;
    margin-top: 50px;
    .logo img {
      width: 107px;
    }

    .title {
      font-size: 37px;
      color: #ffffff;
      line-height: 68px;
      margin-top: 82px;
      font-family: PingFangSC-Medium, PingFang SC;
      span {
        font-weight: 600;
        vertical-align: bottom;
        color: #e10000;
        font-size: 48px;
        padding-right: 6px;
        font-family: PingFangSC-Semibold, PingFang SC;
      }
    }

    .txt {
      margin-top: 24px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 25px;
      font-family: PingFangSC-Regular, PingFang SC;

      span {
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
        height: 25px;
        border-right: 1px solid #fff;
        padding: 0 16px;
        &:nth-child(1) {
          padding-left: 0;
        }
        &:nth-child(3) {
          border-right: none;
        }
      }
    }
  }

  .toTry {
    width: 350px;
    font-size: 16px;
    margin-top: 50px;
    margin-left: 196px;
    padding-bottom: 35px;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    background: #fff;
  }

  a {
    display: block;
    text-decoration: none;
  }

  .btn-line {
    height: 64px;
  }

  .line {
    width: 280px;
    height: 41px;
    position: relative;
    margin: 12px auto 0;

    .form-control.code {
      width: 208px !important;
      height: 40px;
      //   padding-left: 20px !important;
    }

    .active_c {
      color: #ccc;

      &1 {
        color: #297acc;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }
  .company-position {
    position: relative;
    .company-list {
      position: absolute;
      top: 44px;
      width: 300px;
      line-height: 28px;
      max-height: 142px;
      overflow-y: auto;
      background: #fff;
      z-index: 1;
      padding: 10px;
      font-size: 14px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      color: #2C3E50;
      p:hover {
        cursor: pointer;
        background: #f3f3f3;
      }
    }
    .company-list::-webkit-scrollbar {
      width: 8px;
      height: 1px;
    }
    .company-list::-webkit-scrollbar-thumb {
      border-radius: 10px;  
      background: #c0bfbf;  box-shadow: inset 0 0 5px #eae8e8;
    }
    .company-list::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ededed;
      box-shadow: inset 0 0 5px rgba( 0, 0, 0, .1);
    }
  }

  .code-box {
    position: relative;

    .no_border {
      border: 0;
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
        border-color: #fa485a;
      }
    }
  }

  .code-box-boder {
    border-bottom: 1px solid #dedede;
  }

  .code-btn {
    border-radius: 2px;
    position: absolute;
    text-align: right;
    right: 0px;
    bottom: 10px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    cursor: pointer;

    &.disabled {
      background: #ccc;
      color: #fff;
    }
  }

  .active_input {
    border-bottom: 1px solid #e61717;
    color: #e61717;
    font-size: 14px;
  }

  input {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    width: 100%;
    display: block;
    height: 41px;
    border: none;
    border-bottom: 1px solid #dedede;
    padding: 0;
    color: #333;
    outline: 0;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c1c1c1;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c1c1c1;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c1c1c1;
  }

  .btn_zc {
    width: 300px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #297acc;
  }

  .try-tit {
    padding: 32px 0 2px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 33px;
    text-align: center;
  }

  .btn-try {
    width: 280px;
    height: 42px;
    margin: 0 auto;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #fff;
    border-radius: 2px;
    background: #e61717;

    &.bg_active0 {
      background: #e61717;
    }
    &.bg_active1 {
      background: rgba(230, 23, 23, 0.5);
    }
    &:hover {
      background: #d31313;
    }
  }
  .agreement-line {
    height: auto;
    color: #000;
    .wrapper {
      display: flex;
      align-items: center;
    }
    input {
      width: 14px;
      height: 14px;
      display: inline-block;
    }
    span {
      font-size: 13px;
      margin-left: 6px;
    }
    a {
      display: inline-block;
      font-size: 13px;
      color: #1890ff;
    }
    .error-tip {
      font-size: 12px;
      color: red;
      position: absolute;
      bottom: -18px;
    }
  }
}
</style>

<style lang="less">
@import '../../../views/common/components/mixins/bot.less';

.txt_box {
  .bot_slide_pc(@slideHeight: 40px, @slideWidth: 280px);
}
</style>
